import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError, Form } from 'redux-form';
import { push } from 'connected-react-router';
import { PrimaryButton } from 'appSrc/components/UI';
import { FormTextField } from 'appSrc/components/UI/ReduxForm';
import { auth, setTokens, getSelf } from 'appSrc/redux/actions';
import { Auth } from 'appSrc/api';
import { validatePassword } from 'appSrc/utils';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';
import style from './styles/style.module.css';

class LoginForm extends PureComponent {
    constructor( props ) {
        super( props );
    }
    submitHandler = ( values ) => {
        this.props.onWorking();
        // trim whitespace from email address input
        let emailAddress = values.emailAddress;
        if (emailAddress) {
            emailAddress = emailAddress.trim();
        }
        if (emailAddress && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailAddress)) {
            throw new SubmissionError({ emailAddress: 'Invalid email address' });
        } else if ( !values.password || !validatePassword(values.password)) {
            throw new SubmissionError({ password: 'Invalid password' });
        }

        this.props.login( {
            emailAddress: emailAddress,
            password: values.password,
        } )
        .then( ( response ) => {
            this.props.setTokens( response.tokens );
            this.props.getSelf()
            .then( ( self ) => {
                Mixpanel.identify( self.userid );
                Mixpanel.track( 'userLoggedIn' );
            } );
            var query = Object.decodeURLQuery( window.location.search );
            if( query.redirect ) {
                this.props.redirect( window.decodeURIComponent( query.redirect ) );
            }
            if( /\/app\/register\//.test( window.location.pathname ) ) {
                this.props.redirect( '/' );
            }
            this.props.closeModal();
        } );
    }
    render() {
        const { handleSubmit, pristine, submitting } = this.props;
        return (
            <Form className={ style.loginForm } onSubmit={ handleSubmit( this.submitHandler ) }>
                <Field
                name='emailAddress'
                placeholder='Email*'
                component={ FormTextField }
                fullWidth />
                <Field
                name='password'
                type='password'
                component={ FormTextField }
                placeholder='Password*'
                fullWidth />
                <div className={style.signUpButton}>
                    <PrimaryButton
                    label='Login'
                    disabled={ submitting || pristine }
                    type='submit'
                    fullWidth />
                </div>
                { this.props.self.error &&
                    <div className={ style.errorBlock }>{ this.props.self.error }</div>
                }
            </Form>
        );
    }
}
LoginForm.defaultProps = {
    closeModal: ()=>{},
    onWorking: () => {},
};

LoginForm = reduxForm( {
    form: 'LoginForm',
} )( LoginForm );

const mapStateToProps = ( state ) => {
    return {
        facebookStatus: state.facebook.status,
        self: state.self,
        router: state.router,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        setLoggedIn: () => {
            dispatch(auth());
        },
        login: ( data ) => {
            return Auth.login( data );
        },
        redirect: ( url ) => {
            dispatch( push(url) );
        },
        setTokens: ( tokens ) => {
            dispatch( setTokens( tokens ) );
        },
        getSelf: () => {
            return dispatch( getSelf() );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( LoginForm );
